import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=f65d071a&scoped=true&"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=f65d071a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65d071a",
  null
  
)

export default component.exports